import { Component, ViewEncapsulation, Inject, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'checkout-fullscreen-dialog-wrap',
  templateUrl: './checkout-fullscreen-dialog-wrap.component.html',
  encapsulation: ViewEncapsulation.None
})
export class CheckoutFullscreenDialogWrapComponent {

  @Output() onCloseClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  dispose(){
    this.onCloseClick.emit(true);
  }
}